var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0057 17.0906C25.1782 18.9979 24.3089 23.0122 20.9712 24.0596C19.3972 24.5536 16.6351 24.9257 15.1185 24.1951C12.6802 23.0205 13.297 18.9185 14.4035 17.09C15.8609 14.6816 19.6148 15.0531 21.5571 16.7598C22.593 17.67 24.1196 16.1549 23.0776 15.2393C20.4039 12.8899 15.4268 12.2 13.0559 15.2679C11.0642 17.845 10.2893 23.2681 13.1498 25.5823C15.7894 27.7178 21.7408 26.8556 24.1795 24.7331C27.3535 21.9705 26.5221 17.2966 23.091 15.2338C21.9021 14.519 20.8197 16.3776 22.0057 17.0906Z",
    fill: "#222222",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9839 16.88C34.5518 22.4997 30.9175 27.8542 28.3536 32.65C25.4242 38.1295 22.0068 43.2023 17.6377 47.6429C18.2006 47.7155 18.7635 47.788 19.3264 47.8605C16.499 42.9535 13.1996 38.3673 9.93264 33.7482C6.13957 28.3853 1.98654 23.1506 3.24272 16.134C4.43712 9.46246 10.8915 3.60693 17.7615 3.39581C24.2031 3.19785 34.9076 9.65804 34.213 17.1676C34.0856 18.545 36.2368 18.5363 36.3634 17.1676C36.6724 13.8265 35.4296 11.203 33.1241 8.81394C30.8646 6.47256 27.6461 3.42429 24.6007 2.11726C18.2849 -0.593407 10.8433 1.92178 6.25569 6.50833C-7.90233 20.663 10.2364 36.3923 17.4696 48.9459C17.8134 49.5425 18.6744 49.6553 19.1583 49.1635C24.0404 44.2014 27.7348 38.4966 30.9445 32.3411C33.4834 27.472 36.7097 22.5746 36.1343 16.88C35.9965 15.5163 33.8447 15.5021 33.9839 16.88Z",
    fill: "#222222",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.f95f8acaa43c524e74d84a3dd25b2717.svg";
export { ForwardRef as ReactComponent };